import { useState } from 'react';
import { StyleSheet, SafeAreaView, FlatList, Platform, View } from 'react-native';
import { useTheme, } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import ShiftsTemplatesScreen from '../ShiftsTemplatesScreen';
import ShiftsSchedulePeriodsScreen from '../ShiftsSchedulePeriodsScreen';
import CustomButton from '../../../components/CustomButton';
import { TASKS, TASK_OPTIONS } from '../../../constants/Tasks';
import useRole from '../../../hooks/userRole';
import RoleGuard from '../../../components/RoleGuard';

const ShiftsAdmin = (props) => {
    const { colors } = useTheme();
    const styles = makeStyles(colors);
    const { t } = useTranslation();
    const buttonTable = [0, 1, 2, 3];

    const { hasAccess, hasOptionAccess, isAdmin } = useRole();
    const [scheduleScreen, setShowScheduleScreen] = useState(1);
    const [createTemplateScreen, setCreateTemplateScreen] = useState(0);

    const setAllPagesToZero = () => {
        setShowScheduleScreen(0);
        setCreateTemplateScreen(0);
    }

    const showScheduleScreen = () => {
        setAllPagesToZero();
        setShowScheduleScreen(1);
    }

    const showTemplateScreen = () => {
        setAllPagesToZero();
        setCreateTemplateScreen(1);
    }

    return (
        <SafeAreaView style={styles.main}>
            <View style={styles.flatlist}>
                <FlatList
                    horizontal
                    showsHorizontalScrollIndicator={true}
                    directionalLockEnabled={true}
                    alwaysBounceVertical={false}
                    data={buttonTable}
                    contentContainerStyle={{
                        alignSelf: "flex-start",
                    }}
                    showsVerticalScrollIndicator={true} //shows horizontal scroll bar on web
                    renderItem={({ index }) => {
                        return (
                            <SafeAreaView>
                                {index == 1 && isAdmin && (
                                    <RoleGuard parentTask={TASKS.TRAINING} task={TASK_OPTIONS.TRAIN} requireCRUD>
                                        <CustomButton
                                            onPress={() => {
                                                if (createTemplateScreen) return;
                                                showTemplateScreen();
                                            }}
                                            text={t("navigate:shiftTemplate")}
                                            iconName="create-outline"
                                            show={createTemplateScreen ? "HOME_SELECTED" : "HOME"}
                                            type={createTemplateScreen ? "HOME_SELECTED" : "HOME"}
                                            textTop="0"
                                            isGradient={createTemplateScreen ? true : false}
                                            sz={Platform.OS !== "web" ? 20 : 25}
                                        />
                                    </RoleGuard>
                                )}
                                {index == 0 && isAdmin && (
                                    <RoleGuard parentTask={TASKS.TRAINING} task={TASK_OPTIONS.CATEGORIES} requireCRUD>
                                        <CustomButton
                                            onPress={() => {
                                                showScheduleScreen();
                                            }}
                                            text={t("navigate:shiftSchedulePeriods")}
                                            iconName="calendar-outline"
                                            show={scheduleScreen ? "HOME_SELECTED" : "HOME"}
                                            type={scheduleScreen ? "HOME_SELECTED" : "HOME"}
                                            textTop="0"
                                            isGradient={scheduleScreen ? true : false}
                                            sz={Platform.OS !== "web" ? 20 : 25}
                                        />
                                    </RoleGuard>
                                )}

                            </SafeAreaView>
                        );
                    }}
                    keyExtractor={(item) => `${item}`}
                />
            </View>
            <View style={styles.submain}>
                {createTemplateScreen === 1 &&
                    <ShiftsTemplatesScreen />
                }
                {scheduleScreen === 1 &&
                    <ShiftsSchedulePeriodsScreen />
                }
            </View>

        </SafeAreaView>
    )
}

const makeStyles = (colors) => StyleSheet.create({
    main: {
        flex: 1,
    },
    flatlist: {
        flex: 1,
    },
    submain: {
        flex: 10,
    },
})

export default ShiftsAdmin; 